function formatSubMatchLabel(seq) {
  var num = seq < 10 ? '0' + seq : String(seq)
  return '车轮' + num
}

function formatSubMatchHistoryLabel(seq) {
  var num = seq < 10 ? '0' + seq : String(seq)
  return '车轮战 ' + num
}

function normalizeChildGameTeam(childGame, side) {
  var nested = side === 'home' ? childGame.homeTeam : childGame.awayTeam
  var flatId = side === 'home' ? childGame.homeTeamId : childGame.awayTeamId
  var flatName = side === 'home' ? childGame.homeTeamName : childGame.awayTeamName
  if (nested && (nested.id != null || nested.name)) {
    return {
      id: nested.id != null ? String(nested.id) : '',
      name: nested.name || '',
      badge: nested.badge || '',
      clothesColor: nested.clothesColor || nested.clothesColors || ''
    }
  }
  return {
    id: flatId != null ? String(flatId) : '',
    name: flatName || '',
    badge: '',
    clothesColor: ''
  }
}

function isChildGameInProgress(childGame, isCurrent) {
  if (!childGame) {
    return false
  }
  if (childGame.status === 0) {
    return true
  }
  if (childGame.status === 1) {
    return false
  }
  if (isCurrent) {
    return childGame.resultType === 0
  }
  return false
}

function isChildGameCompleted(childGame) {
  if (!childGame) {
    return false
  }
  if (childGame.status === 1) {
    return true
  }
  if (childGame.status === 0) {
    return false
  }
  return childGame.resultType === 1 || childGame.resultType === 2
}

export function childGameToSubMatch(childGame, options) {
  if (!childGame) {
    return null
  }
  options = options || {}
  var isCurrent = !!options.isCurrent
  var seq = childGame.sequenceNo || 1
  var homeTeam = normalizeChildGameTeam(childGame, 'home')
  var awayTeam = normalizeChildGameTeam(childGame, 'away')
  return {
    id: childGame.id != null ? String(childGame.id) : '',
    seq: seq,
    label: childGame.name || formatSubMatchLabel(seq),
    historyLabel: formatSubMatchHistoryLabel(seq),
    status: isChildGameInProgress(childGame, isCurrent) ? 'inProgress' : 'completed',
    homeTeam: homeTeam,
    awayTeam: awayTeam,
    homeScore: childGame.homeScore,
    awayScore: childGame.awayScore
  }
}

export function resolveParentDetailSubMatches(apiDetail) {
  var childGames = (apiDetail && apiDetail.childGames) || []
  var currentSubMatch = childGameToSubMatch(apiDetail && apiDetail.currentChildGame, {
    isCurrent: true
  })
  var currentId = currentSubMatch ? currentSubMatch.id : ''

  if (!currentSubMatch) {
    for (var i = 0; i < childGames.length; i++) {
      if (!isChildGameCompleted(childGames[i])) {
        currentSubMatch = childGameToSubMatch(childGames[i], { isCurrent: true })
        currentId = currentSubMatch ? currentSubMatch.id : ''
        break
      }
    }
  }

  return {
    subMatches: childGamesToSubMatches(childGames, currentId),
    currentSubMatch: currentSubMatch
  }
}

export function childGamesToSubMatches(childGames, currentChildGameId) {
  var currentId = currentChildGameId != null ? String(currentChildGameId) : ''
  return (childGames || [])
    .filter(function (game) {
      if (!game) {
        return false
      }
      if (currentId && String(game.id) === currentId) {
        return false
      }
      return isChildGameCompleted(game)
    })
    .map(function (game) {
      return childGameToSubMatch(game, { isCurrent: false })
    })
    .filter(function (item) {
      return !!item
    })
}

function findTeamInOrder(rotationOrder, teamId) {
  for (var i = 0; i < (rotationOrder || []).length; i++) {
    if (rotationOrder[i].id === teamId) {
      return rotationOrder[i]
    }
  }
  return { id: teamId, name: teamId, badge: '' }
}

export function computeStanding(rotationOrder, childGames) {
  var statsMap = {}
  ;(rotationOrder || []).forEach(function (team) {
    statsMap[team.id] = {
      id: team.id,
      name: team.name,
      badge: team.badge || '',
      played: 0,
      win: 0,
      tie: 0,
      lose: 0,
      points: 0
    }
  })

  var hasConfirmed = false
  ;(childGames || []).forEach(function (game) {
    if (game.status !== 1 && game.status !== undefined) {
      return
    }
    if (game.status === undefined && game.resultType !== 1 && game.resultType !== 2) {
      return
    }
    hasConfirmed = true
    var homeTeam = normalizeChildGameTeam(game, 'home')
    var awayTeam = normalizeChildGameTeam(game, 'away')
    var home = statsMap[homeTeam.id]
    var away = statsMap[awayTeam.id]
    if (!home) {
      home = statsMap[homeTeam.id] = {
        id: homeTeam.id,
        name: homeTeam.name,
        badge: homeTeam.badge || '',
        played: 0,
        win: 0,
        tie: 0,
        lose: 0,
        points: 0
      }
    }
    if (!away) {
      away = statsMap[awayTeam.id] = {
        id: awayTeam.id,
        name: awayTeam.name,
        badge: awayTeam.badge || '',
        played: 0,
        win: 0,
        tie: 0,
        lose: 0,
        points: 0
      }
    }
    home.played += 1
    away.played += 1
    if (game.resultType === 2) {
      home.tie += 1
      away.tie += 1
    } else if (game.winnerTeamId === home.id) {
      home.win += 1
      away.lose += 1
      home.points += 1
    } else if (game.winnerTeamId === away.id) {
      away.win += 1
      home.lose += 1
      away.points += 1
    }
  })

  var list = Object.keys(statsMap).map(function (key) {
    return statsMap[key]
  })
  list.sort(function (a, b) {
    if (b.win !== a.win) {
      return b.win - a.win
    }
    if (b.points !== a.points) {
      return b.points - a.points
    }
    return String(a.id).localeCompare(String(b.id))
  })

  var lastWin = null
  var lastRank = 0
  return list.map(function (item, index) {
    var teamInfo = findTeamInOrder(rotationOrder, item.id)
    var rank = 0
    if (hasConfirmed) {
      if (item.win !== lastWin) {
        lastRank = index + 1
        lastWin = item.win
      }
      rank = lastRank
    }
    return {
      rank: rank,
      team: {
        id: item.id,
        name: teamInfo.name || item.name,
        badge: teamInfo.badge || item.badge || ''
      },
      played: item.played,
      win: item.win,
      tie: item.tie,
      lose: item.lose,
      points: item.points
    }
  })
}
